import React from "react";

import { Avatar, CardHeader, Box, makeStyles } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import PaidBadge from "../PaidBadge";
import ScheduledBadge from "../ScheduledBadge";
import { formatPixelAdLine, formatWaTrackingLine } from "../../utils/pixelCreative";

const useStyles = makeStyles(theme => ({
	root: {
		flex: 1,
		minWidth: 0,
		paddingTop: theme.spacing(0.5),
		paddingBottom: theme.spacing(0.5),
		"& .MuiCardHeader-content": {
			minWidth: 0,
			overflow: "hidden",
		},
		"& .MuiCardHeader-action": {
			margin: 0,
			alignSelf: "center",
			flexShrink: 0,
			maxWidth: "58%",
		},
	},
	titleRow: {
		display: "inline-flex",
		alignItems: "center",
		minWidth: 0,
		maxWidth: "100%",
	},
	name: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	actionWrap: {
		display: "flex",
		justifyContent: "flex-end",
		maxWidth: "100%",
	},
	subheader: {
		display: "flex",
		flexDirection: "column",
		gap: 2,
		minWidth: 0,
	},
	adLine: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		color: "#2563eb",
		fontSize: "0.75rem",
		fontWeight: 500,
	},
	trackingLine: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		color: "#059669",
		fontSize: "0.75rem",
		fontWeight: 600,
	},
}));

const TicketInfo = ({ contact, ticket, onClick, action, pixelTracking }) => {
	const classes = useStyles();
	const assigned =
		ticket.user &&
		`${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`;

	const source = pixelTracking || ticket?.pixelTracking;
	const adLine = formatPixelAdLine(source, {
		adLabel: i18n.t("pixel.adLabel"),
		adId: i18n.t("pixel.adId"),
	});
	const trackingLine = formatWaTrackingLine(source, {
		trackingLabel: i18n.t("pixel.trackingLabel"),
	});

	return (
		<CardHeader
			className={classes.root}
			onClick={onClick}
			style={{ cursor: onClick ? "pointer" : "default" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
			title={
				<Box component="span" className={classes.titleRow}>
					<span className={classes.name}>{`${contact.name} #${ticket.id}`}</span>
					<PaidBadge isPaid={contact?.isPaid} />
					<ScheduledBadge isScheduled={contact?.isScheduled} />
				</Box>
			}
			subheader={
				assigned || adLine || trackingLine ? (
					<span className={classes.subheader}>
						{assigned}
						{adLine ? (
							<span className={classes.adLine} title={adLine}>
								{adLine}
							</span>
						) : null}
						{trackingLine ? (
							<span className={classes.trackingLine} title={trackingLine}>
								{trackingLine}
							</span>
						) : null}
					</span>
				) : null
			}
			action={
				action ? (
					<div
						className={classes.actionWrap}
						onClick={e => e.stopPropagation()}
						onMouseDown={e => e.stopPropagation()}
					>
						{action}
					</div>
				) : null
			}
		/>
	);
};

export default TicketInfo;
